var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/jsx-no-bind */
// Comment: when introducing `react/jsx-no-bind: error` rule, fixing it in this file was out of scope. The file already contains maintenance TODOs. (author Antonin Teichmann, Feb 2025)
import React, { forwardRef, useEffect, useState, } from 'react';
import { styled } from '../../themeCustomink';
import { ColorSwatch } from './ColorSwatch';
import { ToggleButton } from './ToggleButton';
var baseCssName = 'pigment-colorswatchgroup';
var swatchGroupLargeClass = "".concat(baseCssName, "-large");
export var ColorSwatchGroupStyles = styled('div', {
    name: 'pigment-colorswatchgroup',
})(function (_a) {
    var gridGap = _a.gridGap;
    return ({
        display: 'grid',
        gap: gridGap,
    });
});
// TODO: check for performance issues
// This includes enabling react/jsx-no-bind for the file and fixing the issues that arise
var getSubtletyInfo = function (defaultSelected, swatchData) {
    var noSubtletyIssue = [];
    var subtletyIssue = [];
    var defaultIsSubtle = false;
    var defaultSelectedIndex = -1;
    swatchData.forEach(function (data) {
        if (data.startSelected) {
            defaultSelectedIndex = data.subtlety
                ? subtletyIssue.length
                : noSubtletyIssue.length;
            defaultIsSubtle = !!data.subtlety;
        }
        data.subtlety ? subtletyIssue.push(data) : noSubtletyIssue.push(data);
    });
    defaultSelectedIndex =
        defaultIsSubtle && defaultSelectedIndex > -1
            ? defaultSelectedIndex + noSubtletyIssue.length
            : defaultSelectedIndex;
    var startIndex = defaultSelected
        ? defaultSelectedIndex > -1
            ? defaultSelectedIndex
            : 0
        : null;
    return { noSubtletyIssue: noSubtletyIssue, subtletyIssue: subtletyIssue, defaultIsSubtle: defaultIsSubtle, startIndex: startIndex };
};
export var ColorSwatchGroup = forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.defaultSelected, defaultSelected = _b === void 0 ? true : _b, _c = _a.rowCount, rowCount = _c === void 0 ? 0 : _c, _d = _a.gapSize, gapSize = _d === void 0 ? 'small' : _d, _e = _a.size, size = _e === void 0 ? 'small' : _e, swatchData = _a.swatchData, sx = _a.sx, _f = _a.subtletyToggle, subtletyToggle = _f === void 0 ? false : _f, onBlur = _a.onBlur, onFocus = _a.onFocus, onSwatchSelect = _a.onSwatchSelect, onSwatchMouseEnter = _a.onSwatchMouseEnter, onSwatchMouseLeave = _a.onSwatchMouseLeave, onSwatchFocus = _a.onSwatchFocus, onToggleSubtletySwatches = _a.onToggleSubtletySwatches;
    // TODO: Refactor state management //
    var _g = getSubtletyInfo(defaultSelected, swatchData), noSubtletyIssue = _g.noSubtletyIssue, subtletyIssue = _g.subtletyIssue, defaultIsSubtle = _g.defaultIsSubtle, startIndex = _g.startIndex;
    var _h = useState(startIndex), selected = _h[0], setSelected = _h[1];
    var _j = useState(startIndex !== null && startIndex !== void 0 ? startIndex : 0), currentIndex = _j[0], setCurrentIndex = _j[1];
    var _k = useState(subtletyToggle && !defaultIsSubtle), shouldHideSwatches = _k[0], setShouldHideSwatches = _k[1];
    var reorderedSwatchData = noSubtletyIssue.concat(subtletyIssue);
    var maxIndexWhenHidden = noSubtletyIssue.length;
    var maxIndex = swatchData.length;
    var _l = useState(false), isFocused = _l[0], setIsFocused = _l[1];
    // Check if the startIndex has been updated during reloads, and render appropriately.
    useEffect(function () {
        var info = getSubtletyInfo(defaultSelected, swatchData);
        setSelected(info.startIndex);
        setShouldHideSwatches(subtletyToggle && !info.defaultIsSubtle);
    }, [defaultSelected, swatchData]);
    // TODO: Refactor state management //
    var getPreviousSwatch = function () {
        var visibleSwatchesLength = shouldHideSwatches
            ? maxIndexWhenHidden
            : maxIndex;
        var newIndex = (currentIndex + visibleSwatchesLength - 1) % visibleSwatchesLength;
        onSwatchFocus === null || onSwatchFocus === void 0 ? void 0 : onSwatchFocus(reorderedSwatchData[newIndex]);
        setCurrentIndex(newIndex);
    };
    var getNextSwatch = function () {
        var visibleSwatchesLength = shouldHideSwatches
            ? maxIndexWhenHidden
            : maxIndex;
        var newIndex = (currentIndex + 1) % visibleSwatchesLength;
        onSwatchFocus === null || onSwatchFocus === void 0 ? void 0 : onSwatchFocus(reorderedSwatchData[newIndex]);
        setCurrentIndex(newIndex);
    };
    var handleKeyDown = function (e, swatch) {
        if (e.key === 'ArrowLeft') {
            getPreviousSwatch();
        }
        else if (e.key === 'ArrowRight') {
            getNextSwatch();
        }
        else if (e.key === 'Enter') {
            setSelected(currentIndex);
            onSwatchSelect === null || onSwatchSelect === void 0 ? void 0 : onSwatchSelect(swatch);
        }
        else {
            return;
        }
    };
    var handleToggleButton = function () {
        setShouldHideSwatches(false);
        currentIndex && setSwatchSetStates(currentIndex);
        onToggleSubtletySwatches === null || onToggleSubtletySwatches === void 0 ? void 0 : onToggleSubtletySwatches();
    };
    var setSwatchSetStates = function (id) {
        var _a;
        if (ref) {
            var swatchRef = ref;
            (_a = swatchRef === null || swatchRef === void 0 ? void 0 : swatchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        setSelected(id);
        setCurrentIndex(id);
    };
    var handleBlur = function (evt) {
        setIsFocused(false);
        selected && setCurrentIndex(selected);
        onBlur && onBlur(evt);
    };
    var handleFocus = function (evt) {
        setIsFocused(true);
        onFocus && onFocus(evt);
    };
    var gridGap = gapSize === 'large' ? '0.75rem' : '0.5rem';
    var createSwatch = function (data, idx, gapSize) {
        return (React.createElement(ColorSwatch, { key: idx, color: data.color, dogEar: data.dogEar, trimRgb: data.trimRgb, focused: idx === currentIndex && isFocused, selected: idx === selected, size: size, special: data.special, subtlety: data.subtlety, value: data.value, onClick: function () {
                setSwatchSetStates(idx);
                onSwatchSelect === null || onSwatchSelect === void 0 ? void 0 : onSwatchSelect(data);
            }, onMouseEnter: function () { return onSwatchMouseEnter === null || onSwatchMouseEnter === void 0 ? void 0 : onSwatchMouseEnter(data); }, onMouseLeave: function () { return onSwatchMouseLeave === null || onSwatchMouseLeave === void 0 ? void 0 : onSwatchMouseLeave(data); }, tabIndex: -1, sx: {
                height: 'unset !important',
                width: 'unset !important',
                position: 'relative',
                '&::after': {
                    content: '""',
                    display: 'block',
                    margin: "calc(-".concat(gapSize, " / 2)") /* half of the gap size, so continuous click area */,
                    paddingTop: "calc(100% + ".concat(gapSize, ")") /* Aspect ratio 1:1. the gap size is added to preserve ratios at different gaps */,
                },
            } }));
    };
    var fixedRow = "repeat(".concat(rowCount, ", ").concat(size === 'large' ? '32px' : '24px', ")");
    var singleRow = "repeat(auto-fill, minmax(".concat(size === 'large' ? '30px' : '23px', ", 1fr))"); // set to slightly smaller than target swatch size to prevent too-large swatches in narrow spaces
    return (React.createElement(ColorSwatchGroupStyles, { "data-testid": "ColorSwatchGroup", className: size === 'large' ? "".concat(swatchGroupLargeClass, " ") : '' + className, tabIndex: 0, onKeyDown: function (e) { return handleKeyDown(e, reorderedSwatchData[currentIndex]); }, onBlur: function (e) { return handleBlur(e); }, onFocus: function (e) { return handleFocus(e); }, ref: ref, gridGap: gridGap, sx: __assign({ gridTemplateColumns: rowCount > 0 ? fixedRow : singleRow, gridAutoRows: '1fr' }, sx) }, noSubtletyIssue === null || noSubtletyIssue === void 0 ? void 0 :
        noSubtletyIssue.map(function (swatch, idx) {
            return createSwatch(swatch, idx, gridGap);
        }),
        !shouldHideSwatches &&
            (subtletyIssue === null || subtletyIssue === void 0 ? void 0 : subtletyIssue.map(function (swatch, idx) {
                return createSwatch(swatch, idx + noSubtletyIssue.length, gridGap);
            })),
        shouldHideSwatches && subtletyIssue.length > 0 ? (React.createElement(ToggleButton, { count: subtletyIssue.length, onClick: function () { return handleToggleButton(); }, onKeyDown: function (e) {
                e.key === 'Enter' ? handleToggleButton() : undefined;
            }, tabIndex: 0 })) : null));
});
//# sourceMappingURL=ColorSwatchGroup.js.map